import React from "react";

const PublicSurveyDetails = React.lazy(() => import("@pages/public/surveys/PublicSurveyDetail"));
const PublicSurveyQuestions = React.lazy(() => import("@pages/public/surveys/PublicSurveyQuestions"));
const SurveyThankYou = React.lazy(() => import("@pages/public/surveys/PublicSurveyThankYou"));


export const publicRoutes = [
    {
    caseSensitive: true,
    path: "/survey/:companyName/:surveyId",
    element: <PublicSurveyDetails />,
  },{
    caseSensitive: true,
    path: "/public/survey/:surveyId/thankyou",
    element: <SurveyThankYou />,
  },{
    caseSensitive: true,
    path: "/public/survey/:surveyId/questions",
    element: <PublicSurveyQuestions />,
  },
  
  ]